import { useEffect, useRef, useState } from "react";
import { collection, getDocs, query } from "firebase/firestore";
import { db } from "../../services/firebase.config";
import { useAuth } from "../../services/AuthContext";

export const useQuickAddUsers = (userProfile) => {
  const { currentUserState } = useAuth();
  const [quickAddUsers, setQuickAddUsers] = useState([]);
  const currentUserRef = useRef(currentUserState);

  useEffect(() => {
    currentUserRef.current = currentUserState;
  }, [currentUserState]);

  useEffect(() => {
    const fetchQuickAdd = async () => {
      const user = currentUserRef.current;
      if (!user) return;
      try {
        const usersQuery = query(collection(db, "public-profiles"));
        const snapshot = await getDocs(usersQuery);
        const users = [];
        const myFriendIds = new Set(userProfile?.friends || []);
        snapshot.forEach((docSnap) => {
          const data = docSnap.data();
          const hasPendingRequest =
            userProfile?.friendRequests?.sent?.includes(docSnap.id) ||
            userProfile?.friendRequests?.received?.includes(docSnap.id);
          const candidateFriendIds = Array.isArray(data.friends)
            ? data.friends
            : [];
          const hasMutualFriend = candidateFriendIds.some((fid) =>
            myFriendIds.has(fid)
          );

          if (
            docSnap.id !== user.uid &&
            !(userProfile?.friends || []).includes(docSnap.id) &&
            !hasPendingRequest &&
            hasMutualFriend &&
            data.username &&
            data.username.trim() !== ""
          ) {
            users.push({ id: docSnap.id, ...data });
          }
        });
        for (let i = users.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [users[i], users[j]] = [users[j], users[i]];
        }
        setQuickAddUsers(users.slice(0, 10));
      } catch (_) {
        setQuickAddUsers([]);
      }
    };
    fetchQuickAdd();
  }, [userProfile]);

  return { quickAddUsers };
};
